
(function() {
  'use strict';

  var initialized = false;
  var toastTimer = null;

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function formatMoney(cents) {
    var amount = (parseInt(cents || 0, 10) / 100);
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
    } catch (e) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function getCartUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
  }

  function ensureToast() {
    var toast = document.querySelector('.asgard-toast');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'asgard-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = [
      '<p class="asgard-toast-title">ASGARD</p>',
      '<p class="asgard-toast-text"></p>',
      '<div class="asgard-toast-actions">',
      '<a href="' + getCartUrl() + '">Voir panier</a>',
      '<button type="button" data-asgard-toast-close>Continuer</button>',
      '</div>'
    ].join('');
    document.body.appendChild(toast);

    toast.querySelector('[data-asgard-toast-close]').addEventListener('click', function() {
      toast.classList.remove('is-visible');
    });

    return toast;
  }

  function showToast(message, title) {
    var toast = ensureToast();
    var titleEl = toast.querySelector('.asgard-toast-title');
    var textEl = toast.querySelector('.asgard-toast-text');
    if (titleEl) titleEl.textContent = title || 'ASGARD';
    if (textEl) textEl.textContent = message;
    toast.classList.add('is-visible');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 4300);
  }

  function updateCartCount(count) {
    var numeric = parseInt(count || 0, 10);
    qsa('.asgard-nav-cart').forEach(function(link) {
      var countEl = link.querySelector('.asgard-nav-cart-count');
      if (numeric > 0) {
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'asgard-nav-cart-count';
          link.appendChild(countEl);
        }
        countEl.textContent = numeric;
      } else if (countEl) {
        countEl.remove();
      }

      link.classList.remove('asgard-cart-bump');
      void link.offsetWidth;
      link.classList.add('asgard-cart-bump');
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(response) {
      if (!response.ok) throw new Error('Panier indisponible');
      return response.json();
    });
  }

  function initMobileNavigation(root) {
    qsa('.asgard-main-header', root).forEach(function(header) {
      if (header.dataset.asgardMobileNav === 'true') return;
      var inner = header.querySelector('.asgard-main-header-inner');
      var nav = header.querySelector('.asgard-nav');
      if (!inner || !nav) return;

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'asgard-nav-toggle';
      toggle.setAttribute('aria-label', 'Ouvrir le menu');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.innerHTML = '<span></span><span></span><span></span>';
      inner.insertBefore(toggle, nav);

      toggle.addEventListener('click', function() {
        var open = header.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      });

      qsa('a', nav).forEach(function(link) {
        link.addEventListener('click', function() {
          header.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      });

      header.dataset.asgardMobileNav = 'true';
    });
  }

  function initActiveLinks(root) {
    var current = window.location.pathname.replace(/\/$/, '') || '/';
    qsa('.asgard-nav-link[href]', root).forEach(function(link) {
      var path;
      try {
        path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '') || '/';
      } catch (e) {
        return;
      }
      link.classList.toggle('is-active', path === current);
    });
  }


  function initClothingDropdown(root) {
    qsa('[data-asgard-dropdown]', root).forEach(function(dropdown) {
      if (dropdown.dataset.asgardDropdownReady === 'true') return;

      var toggle = dropdown.querySelector('[data-asgard-dropdown-toggle]');
      var items = qsa('.asgard-nav-dropdown-item', dropdown);
      if (!toggle) return;

      function setOpen(open) {
        dropdown.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function(event) {
        event.preventDefault();
        var willOpen = !dropdown.classList.contains('is-open');
        qsa('[data-asgard-dropdown]').forEach(function(other) {
          if (other !== dropdown) {
            other.classList.remove('is-open');
            var otherToggle = other.querySelector('[data-asgard-dropdown-toggle]');
            if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          }
        });
        setOpen(willOpen);
      });

      toggle.addEventListener('keydown', function(event) {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setOpen(true);
          if (items[0]) items[0].focus();
        }
        if (event.key === 'Escape') {
          setOpen(false);
          toggle.focus();
        }
      });

      items.forEach(function(item, index) {
        item.addEventListener('keydown', function(event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            setOpen(false);
            toggle.focus();
          }
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            (items[index + 1] || items[0]).focus();
          }
          if (event.key === 'ArrowUp') {
            event.preventDefault();
            (items[index - 1] || items[items.length - 1]).focus();
          }
        });
      });

      var current = window.location.pathname.replace(/\/$/, '') || '/';
      var hasActiveItem = items.some(function(item) {
        try {
          var path = new URL(item.href, window.location.origin).pathname.replace(/\/$/, '') || '/';
          return path === current || current.indexOf(path + '/') === 0;
        } catch (e) {
          return false;
        }
      });
      dropdown.classList.toggle('is-active', hasActiveItem);

      dropdown.dataset.asgardDropdownReady = 'true';
    });

    if (!window.__asgardDropdownOutsideClick) {
      window.__asgardDropdownOutsideClick = true;
      document.addEventListener('click', function(event) {
        qsa('[data-asgard-dropdown]').forEach(function(dropdown) {
          if (!dropdown.contains(event.target)) {
            dropdown.classList.remove('is-open');
            var toggle = dropdown.querySelector('[data-asgard-dropdown-toggle]');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          }
        });
      });
      document.addEventListener('keydown', function(event) {
        if (event.key !== 'Escape') return;
        qsa('[data-asgard-dropdown].is-open').forEach(function(dropdown) {
          dropdown.classList.remove('is-open');
          var toggle = dropdown.querySelector('[data-asgard-dropdown-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  function enhanceQuantityInputs(root) {
    qsa('input.asgard-cart-qty-input, input.asgard-air-quantity-input, form.asgard-product-form input[name="quantity"]', root).forEach(function(input) {
      if (input.dataset.asgardQty === 'true') return;
      if (input.type !== 'number' && input.type !== 'hidden') return;
      if (input.type === 'hidden') return;

      var minus = document.createElement('button');
      var plus = document.createElement('button');
      minus.type = 'button';
      plus.type = 'button';
      minus.className = 'asgard-qty-btn asgard-qty-btn--minus';
      plus.className = 'asgard-qty-btn asgard-qty-btn--plus';
      minus.setAttribute('aria-label', 'Diminuer la quantité');
      plus.setAttribute('aria-label', 'Augmenter la quantité');
      minus.textContent = '−';
      plus.textContent = '+';

      input.parentNode.insertBefore(minus, input);
      if (input.nextSibling) {
        input.parentNode.insertBefore(plus, input.nextSibling);
      } else {
        input.parentNode.appendChild(plus);
      }

      function change(delta) {
        var min = parseInt(input.getAttribute('min') || '0', 10);
        var current = parseInt(input.value || min || 0, 10);
        var next = Math.max(min, current + delta);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      minus.addEventListener('click', function() { change(-1); });
      plus.addEventListener('click', function() { change(1); });
      input.dataset.asgardQty = 'true';
    });
  }

  function initProductForms(root) {
    qsa('form.asgard-product-form', root).forEach(function(form) {
      if (form.dataset.asgardAjaxForm === 'true') return;

      form.addEventListener('submit', function(event) {
        if (!window.fetch || form.dataset.noAjax === 'true') return;

        var idField = form.querySelector('[name="id"]');
        var submit = form.querySelector('button[type="submit"], input[type="submit"]');
        if (!idField || (submit && submit.disabled)) return;

        event.preventDefault();

        var originalText = submit ? submit.textContent : '';
        form.classList.add('is-loading');
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Ajout...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().catch(function() { return {}; }).then(function(error) {
              throw new Error(error.description || error.message || 'Impossible d’ajouter ce produit.');
            });
          }
          return response.json();
        })
        .then(function(item) {
          return fetchCart().then(function(cart) {
            updateCartCount(cart.item_count);
            var title = item.product_title || item.title || 'Produit';
            showToast(title + ' a été ajouté au panier.', 'Ajouté au panier');
            if (submit) submit.textContent = 'Ajouté ✓';
            window.setTimeout(function() {
              if (submit) {
                submit.disabled = false;
                submit.textContent = submit.getAttribute('data-default-label') || originalText || 'Ajouter';
              }
              form.classList.remove('is-loading');
            }, 900);
          });
        })
        .catch(function(error) {
          showToast(error.message || 'Une erreur est survenue.', 'Erreur');
          if (submit) {
            submit.disabled = false;
            submit.textContent = submit.getAttribute('data-default-label') || originalText || 'Ajouter';
          }
          form.classList.remove('is-loading');
        });
      });

      form.dataset.asgardAjaxForm = 'true';
    });
  }

  function initCartAjax(root) {
    var cartRoot = (root || document).querySelector('.asgard-cart');
    if (!cartRoot || cartRoot.dataset.asgardCartAjax === 'true') return;

    function updateItemByKey(key, quantity, article) {
      if (!key) return;
      if (article) article.classList.add('is-loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: Math.max(0, parseInt(quantity || 0, 10)) })
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Modification impossible');
        return response.json();
      })
      .then(function(cart) {
        updateCartCount(cart.item_count);

        qsa('[data-cart-subtotal]').forEach(function(el) {
          el.textContent = formatMoney(cart.items_subtotal_price || cart.total_price || 0);
        });

        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }

        var item = cart.items.find(function(cartItem) { return cartItem.key === key; });
        if (!item) {
          if (article) article.remove();
        } else if (article) {
          var input = article.querySelector('.asgard-cart-qty-input');
          var price = article.querySelector('[data-cart-line-price]');
          if (input) input.value = item.quantity;
          if (price) price.textContent = formatMoney(item.final_line_price);
        }

        if (article) article.classList.remove('is-loading');
        showToast('Panier mis à jour.', 'Panier');
      })
      .catch(function(error) {
        if (article) article.classList.remove('is-loading');
        showToast(error.message || 'Impossible de modifier le panier.', 'Erreur');
      });
    }

    qsa('.asgard-cart-qty-input', cartRoot).forEach(function(input) {
      var timer = null;
      input.addEventListener('change', function() {
        var article = input.closest('.asgard-cart-item');
        var key = input.getAttribute('data-cart-key') || (article && article.getAttribute('data-cart-key'));
        clearTimeout(timer);
        timer = setTimeout(function() {
          updateItemByKey(key, input.value, article);
        }, 220);
      });
    });

    qsa('[data-cart-remove]', cartRoot).forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        var article = button.closest('.asgard-cart-item');
        var key = button.getAttribute('data-cart-key') || (article && article.getAttribute('data-cart-key'));
        updateItemByKey(key, 0, article);
      });
    });

    cartRoot.dataset.asgardCartAjax = 'true';
  }

  function initDrinksSlider(root) {
    qsa('.asgard-drinks-track-wrapper', root).forEach(function(wrapper) {
      if (wrapper.dataset.asgardDrag === 'true') return;

      wrapper.setAttribute('tabindex', '0');
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var hasDragged = false;
      var pressedLink = null;

      wrapper.addEventListener('pointerdown', function(event) {
        isDown = true;
        hasDragged = false;
        startX = event.clientX;
        scrollLeft = wrapper.scrollLeft;
        pressedLink = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      });

      wrapper.addEventListener('pointermove', function(event) {
        if (!isDown) return;
        var dx = event.clientX - startX;
        if (Math.abs(dx) > 5) {
          hasDragged = true;
          wrapper.classList.add('is-dragging');
          wrapper.scrollLeft = scrollLeft - dx;
          event.preventDefault();
        }
      });

      wrapper.addEventListener('click', function(event) {
        if (hasDragged) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function(type) {
        wrapper.addEventListener(type, function(event) {
          var shouldOpenLink = type === 'pointerup' && pressedLink && wrapper.contains(pressedLink) && !hasDragged;
          isDown = false;
          wrapper.classList.remove('is-dragging');

          if (shouldOpenLink) {
            var href = pressedLink.getAttribute('href');
            if (href && href !== '#') {
              window.location.href = pressedLink.href;
            }
          }

          pressedLink = null;
        });
      });

      wrapper.addEventListener('keydown', function(event) {
        var rootEl = wrapper.closest('.asgard-drinks-slider');
        if (!rootEl) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          var next = rootEl.querySelector('.asgard-drinks-arrow--next');
          if (next) next.click();
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          var prev = rootEl.querySelector('.asgard-drinks-arrow--prev');
          if (prev) prev.click();
        }
      });

      wrapper.dataset.asgardDrag = 'true';
    });
  }

  function initReveal(root) {
    var candidates = qsa('.asgard-drinks-hero, .asgard-drinks-item, .asgard-air-panel, .asgard-air-bottom, .asgard-cart-panel, .asgard-account-card, .asgard-clothing-hero, .asgard-clothing-card', root);
    candidates.forEach(function(el) {
      if (!el.classList.contains('asgard-reveal')) el.classList.add('asgard-reveal');
    });

    if (!('IntersectionObserver' in window)) {
      candidates.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });

    candidates.forEach(function(el) {
      if (!el.classList.contains('is-visible')) observer.observe(el);
    });
  }

  function initProductModal(root) {
    qsa('.asgard-air-ghost-btn', root).forEach(function(button) {
      if (button.dataset.asgardModal === 'true') return;
      button.addEventListener('click', function(event) {
        event.preventDefault();
        var productRoot = button.closest('.asgard-product');
        var title = productRoot && productRoot.querySelector('.asgard-air-title') ? productRoot.querySelector('.asgard-air-title').textContent.trim() : 'ASGARD Energy';
        var subtitle = productRoot && productRoot.querySelector('.asgard-air-subtitle') ? productRoot.querySelector('.asgard-air-subtitle').textContent.trim() : 'Une expérience Asgard prête à être enrichie avec votre vidéo produit.';
        openModal(title, 'Emplacement vidéo interactif. Connecte ici ta vidéo produit, un réel ou un contenu de présentation dans une prochaine évolution. ' + subtitle);
      });
      button.dataset.asgardModal = 'true';
    });
  }

  function openModal(title, text) {
    var modal = document.querySelector('.asgard-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'asgard-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = [
        '<div class="asgard-modal-card">',
        '<button type="button" class="asgard-modal-close" aria-label="Fermer">×</button>',
        '<h2 class="asgard-modal-title"></h2>',
        '<p class="asgard-modal-text"></p>',
        '</div>'
      ].join('');
      document.body.appendChild(modal);
      modal.addEventListener('click', function(event) {
        if (event.target === modal || event.target.classList.contains('asgard-modal-close')) {
          modal.classList.remove('is-open');
        }
      });
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') modal.classList.remove('is-open');
      });
    }

    modal.querySelector('.asgard-modal-title').textContent = title;
    modal.querySelector('.asgard-modal-text').textContent = text;
    modal.classList.add('is-open');
  }

  function initHeroKeyboard() {
    if (window.__asgardKeyboardInitialized) return;
    window.__asgardKeyboardInitialized = true;

    document.addEventListener('keydown', function(event) {
      var key = event.key;
      if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'PageDown', 'PageUp', ' '].includes(key)) return;
      var frames = qsa('.asgard-frame');
      if (!frames.length) return;

      var active = frames.find(function(frame) {
        var section = frame.closest('[id^="shopify-section-"]');
        return section && (section.style.opacity === '1' || getComputedStyle(section).opacity === '1');
      });
      if (!active) return;

      var buttons = qsa('.asgard-pager button', active);
      if (buttons.length < 2) return;

      if (['ArrowDown', 'ArrowRight', 'PageDown', ' '].includes(key)) {
        event.preventDefault();
        buttons[1].click();
      }
      if (['ArrowUp', 'ArrowLeft', 'PageUp'].includes(key)) {
        event.preventDefault();
        buttons[0].click();
      }
    });
  }


  function ensureWinterEffects() {
    document.documentElement.classList.add('asgard-winter-ready');

    try {
      if (window.matchMedia && window.matchMedia('(max-width: 760px)').matches) {
        document.documentElement.classList.add('asgard-winter-mobile-light');
        return;
      }
    } catch (e) {}

    if (!document.querySelector('.asgard-frost-overlay')) {
      var frost = document.createElement('div');
      frost.className = 'asgard-frost-overlay';
      frost.setAttribute('aria-hidden', 'true');
      document.body.appendChild(frost);
    }

    if (document.querySelector('.asgard-snow-scene')) return;

    var scene = document.createElement('div');
    scene.className = 'asgard-snow-scene';
    scene.setAttribute('aria-hidden', 'true');

    var fragment = document.createDocumentFragment();
    var flakeSymbols = ['✦', '❄', '•'];

    for (var i = 0; i < 34; i++) {
      var flake = document.createElement('span');
      var size = (Math.random() * 16 + 8).toFixed(2);
      flake.className = 'asgard-snowflake';
      flake.textContent = flakeSymbols[i % flakeSymbols.length];
      flake.style.left = (Math.random() * 100).toFixed(2) + '%';
      flake.style.setProperty('--asgard-snow-size', size + 'px');
      flake.style.setProperty('--asgard-snow-duration', (Math.random() * 8 + 10).toFixed(2) + 's');
      flake.style.setProperty('--asgard-snow-delay', (-Math.random() * 18).toFixed(2) + 's');
      flake.style.setProperty('--asgard-snow-drift', (Math.random() * 80 - 40).toFixed(2) + 'px');
      flake.style.opacity = (Math.random() * 0.45 + 0.25).toFixed(2);
      fragment.appendChild(flake);
    }

    scene.appendChild(fragment);
    document.body.appendChild(scene);
  }


  function initEntryLoader() {
    if (window.__asgardEntryLoaderReady) return;
    window.__asgardEntryLoaderReady = true;

    var loader = document.querySelector('[data-asgard-entry-loader]');
    if (!loader) {
      document.body.classList.remove('asgard-loader-active');
      return;
    }

    var video = loader.querySelector('video');
    var skip = loader.querySelector('[data-asgard-entry-loader-skip]');
    var closed = false;
    var fallbackTimer = null;
    var reduceMotion = false;

    try {
      reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}

    function hasAlreadyPlayed() {
      try {
        return window.sessionStorage.getItem('asgard-entry-loader-seen') === 'true';
      } catch (e) {
        return false;
      }
    }

    function rememberPlayed() {
      try {
        window.sessionStorage.setItem('asgard-entry-loader-seen', 'true');
        document.documentElement.classList.add('asgard-entry-loader-seen');
      } catch (e) {}
    }

    function closeLoader(immediate) {
      if (closed) return;
      closed = true;
      rememberPlayed();
      clearTimeout(fallbackTimer);
      if (video) {
        try { video.pause(); } catch (e) {}
      }
      if (immediate) {
        loader.remove();
        document.body.classList.remove('asgard-loader-active');
        return;
      }
      loader.classList.add('is-hiding');
      document.body.classList.remove('asgard-loader-active');
      setTimeout(function() {
        if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
      }, 780);
    }

    if (hasAlreadyPlayed()) {
      closeLoader(true);
      return;
    }

    if (skip) {
      skip.addEventListener('click', function() {
        closeLoader(false);
      });
    }

    if (reduceMotion) {
      fallbackTimer = setTimeout(function() {
        closeLoader(false);
      }, 1400);
      return;
    }

    if (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      video.addEventListener('ended', function() {
        setTimeout(function() {
          closeLoader(false);
        }, 450);
      });

      video.addEventListener('error', function() {
        fallbackTimer = setTimeout(function() {
          closeLoader(false);
        }, 1800);
      });

      var playPromise;
      try {
        playPromise = video.play();
      } catch (e) {
        playPromise = null;
      }

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {
          fallbackTimer = setTimeout(function() {
            closeLoader(false);
          }, 2600);
        });
      }
    }

    fallbackTimer = setTimeout(function() {
      closeLoader(false);
    }, 9300);
  }

  function init(root) {
    var scope = root || document;
    document.documentElement.classList.add('asgard-js-ready');
    initMobileNavigation(scope);
    initActiveLinks(scope);
    initClothingDropdown(scope);
    enhanceQuantityInputs(scope);
    initProductForms(scope);
    initCartAjax(scope);
    initDrinksSlider(scope);
    initReveal(scope);
    initProductModal(scope);
    initHeroKeyboard();
    ensureWinterEffects();
  }

  function boot() {
    if (initialized) return;
    initialized = true;
    initEntryLoader();
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target || document);
  });
})();
